import React, { useState, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  Alert,
  StyleSheet,
  Modal,
  ScrollView,
  TextInput,
  ActivityIndicator,
  Image,
} from "react-native";

import { useTranslation } from "react-i18next";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";

import { observer, Observer } from "mobx-react";

import NoTranslateText from "../../Components/NoTranslateText";

import { Octicons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { useScreenDimensions } from "../../_layout";

import BlackPng from "../../../assets/BlackPng.png";

const StripeRates = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  const { screenHeight } = useScreenDimensions();

  const hasSale = false;

  const WhatsIncludedBox = () => {
    const originalWidth = 4005;
    const originalHeight = 2604;
    const aspectRatio = originalWidth / originalHeight;

    const newWidth = 50;
    const newHeight = newWidth / aspectRatio;

    const BulletText = ({ text, noTranslate = false }) => {
      return (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 15,
          }}
        >
          <Ionicons
            name="checkmark-circle"
            size={20}
            color={Colors.bubbleColor}
            style={GlobalStyles.rowIcon}
          />
          <Text translate={noTranslate ? "no" : undefined}>{text}</Text>
        </View>
      );
    };

    return (
      <View
        style={{ width: "50%", paddingRight: 20, justifyContent: "center" }}
      >
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            marginBottom: 40,
            marginTop: 20,
          }}
        >
          <Image
            source={BlackPng}
            style={{
              width: newWidth,
              height: newHeight,
              //   opacity: 0.8,
              // marginLeft: 20,
            }}
          />
        </View>
        <NoTranslateText style={{ fontWeight: "bold", marginBottom: 20 }}>
          ¿Qué incluye Efort Coach?
        </NoTranslateText>
        <BulletText text={"Acceso completo a todas las herramientas."} />
        <BulletText text={"Gestión centralizada de atletas."} />
        <BulletText
          text={"Tus atletas reciben la planificación en Efort."}
          noTranslate={true}
        />
        <BulletText text={"Actualización automática de datos en la nube."} />
        <BulletText text={"Análisis y estadísticas ilimitados."} />
      </View>
    );
  };

  const SelectRateBox = () => {
    const RateRow = ({ rate, price }) => {
      const salePrice = Math.ceil(Number(price) * 0.3);
      return (
        <View
          style={[
            GlobalStyles.touchableRow,
            {
              shadowColor: Colors.bubbleColor,
              borderWidth: 1,
              borderColor: Colors.borderColor,
              justifyContent: "space-between",
              marginBottom: rate !== "Más de 50 atletas" && 10,
            },
          ]}
        >
          <Text style={Fonts.medium16}>{rate}</Text>
          {hasSale ? (
            <View style={{ flexDirection: "row" }}>
              <Text
                style={[
                  Fonts.medium16,
                  {
                    marginRight: 10,
                    color: "red",
                  },
                ]}
              >
                {salePrice} €
              </Text>
              <Text
                style={[
                  Fonts.medium16,
                  {
                    textDecorationLine: "line-through",
                    // marginRight: 5,
                    // textDecorationColor: "red",
                  },
                ]}
              >
                {price} €
              </Text>
              <Text
                style={[
                  Fonts.medium16,
                  {
                    // textDecorationColor: "red",
                  },
                ]}
              >
                {" "}
                / mes
              </Text>
            </View>
          ) : (
            <Text style={Fonts.medium16}> {price} € / mes</Text>
          )}
        </View>
      );
    };
    return (
      <View style={{ width: "50%", paddingLeft: 20, justifyContent: "center" }}>
        <RateRow rate={"Hasta 5 atletas"} price={"9.99"} />
        <RateRow rate={"Hasta 15 atletas"} price={"24.99"} />
        <RateRow rate={"Hasta 30 atletas"} price={"39.99"} />
        <RateRow rate={"Hasta 50 atletas"} price={"59.99"} />
        <RateRow rate={"Más de 50 atletas"} price={"89.99"} />
      </View>
    );
  };

  const Sale = () => {
    const CountdownTimer = () => {
      const calculateTimeLeft = () => {
        // Get the current year to construct the target date
        const year = new Date().getUTCFullYear();
        // Assuming the targetDate is in UTC
        const targetDate = Date.UTC(year, 2, 25, 10, 0, 0); // Note: Months are 0-indexed
        // Get the current time in UTC
        const now = new Date().getTime();

        // Calculate the difference in milliseconds
        const difference = targetDate - now;

        // Calculate total time left
        let timeLeft = {};

        if (difference > 0) {
          timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          };
        }

        return timeLeft;
      };

      const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

      useEffect(() => {
        const timer = setTimeout(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
      });

      return (
        <View style={{ marginTop: 10 }}>
          <Text style={{ fontSize: 20 }}>
            {timeLeft.days || "0"}d : {timeLeft.hours || "0"}h :{" "}
            {timeLeft.minutes || "0"}m : {timeLeft.seconds || "0"}s
          </Text>
        </View>
      );
    };

    return (
      hasSale && (
        <View style={{ alignItems: "center" }}>
          <View
            style={{
              width: "100%",
              marginTop: 20,
              backgroundColor: Colors.bubbleColor,
              alignItems: "center",
            }}
          >
            <Text
              style={[
                Fonts.medium22,
                { padding: 10, color: Colors.whiteColor },
              ]}
            >
              -70% DE DESCUENTO DURANTE LOS PRIMEROS 3 MESES
            </Text>
          </View>
          <CountdownTimer />
        </View>
      )
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={[styles.modalView, { maxHeight: screenHeight * 0.9 }]}>
            <Sale />
            <ScrollView
              style={{ flex: 1, padding: 20 }}
              showsVerticalScrollIndicator={false}
            >
              <View
                style={{
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <WhatsIncludedBox />
                <View style={styles.verticalDivider} />
                <SelectRateBox />
              </View>
            </ScrollView>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    width: 800,
    // maxHeight: screenHeight * 0.5,
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
  },
  textInputStyle: {
    width: "100%",
    height: 40,
    borderColor: "gray",
    borderWidth: 1,
    marginBottom: 20,
    padding: 10,
    borderRadius: 10,
  },
  saveButtonStyle: {
    backgroundColor: "#2196F3",
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    width: "100%",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 16,
  },
  textInputStyle: {
    // height: 40,
    // marginBottom: 20,
    // marginHorizontal: 10,
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 16,
    // backgroundColor: "red",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    borderWidth: 0.2,
    borderColor: Colors.grayColor,
    marginBottom: 20,
    borderRadius: 10,
    height: 40,
    backgroundColor: "transparent",
  },
  verticalDivider: {
    width: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
  },
  horizontalDivider: {
    height: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
    marginTop: 40,
  },
});

export default StripeRates;
